module.exports = __webpack_public_path__ + "img/compatible_zh-tw.b2dd36e7.png";